import { motion } from "framer-motion";
import { Zap, MonitorSmartphone, MessageCircle, Clock } from "lucide-react";

const items = [
  { icon: Zap, text: "Activación en minutos" },
  { icon: MonitorSmartphone, text: "Smart TV, Fire TV, Android, iPhone y PC" },
  { icon: MessageCircle, text: "Atención por WhatsApp" },
  { icon: Clock, text: "Disponible 24/7" },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="relative border-y border-bp-border bg-bp-surface">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-5 gap-x-4">
          {items.map((it, i) => (
            <motion.div
              key={it.text}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-3"
            >
              <span className="grid place-items-center w-10 h-10 rounded-lg bg-bp-primary/12 text-bp-primary shrink-0">
                <it.icon className="w-5 h-5" />
              </span>
              <span className="text-sm text-[#D4D4D4] font-medium leading-tight">{it.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
